import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import Icon from 'src/components/Icon/Icon';

function SportMarket() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [orderBy, setOrderBy] = useState(null);

  const loadBetCodes = async () => {
    const data = await dispatch.events.getBetCodes(1);

    setData(_.map(data, (market) => {
      return {
        betCardCode: market.betCardCode,
        name: `${ market.market_type.name } - ${ market.name }`,
        betCode: market.betCode,
        specifier1: market.specifier1,
        specifier2: market.specifier2,
        specValue1: market.specValue1,
        specValue2: market.specValue2
      };
    }));
  };

  useEffect(() => {
    loadBetCodes();
  }, []);

  const sort = (name) => {
    setOrderBy(name === orderBy ? '' : name);
    setData(_.orderBy(data, name, name === orderBy ? 'asc' : 'desc'));
  };

  return (
    <>
      <thead className="type-codes__header">
        <tr>
          <th>
            { t('typeCodes.name') }
            <Icon
              onClick={ () => sort('name') }
              className={
                classNames({
                  'type-codes__arrow': true,
                  'type-codes__arrow--sorted': orderBy === 'name'
                })
              }
              icon="arrow"
            />
          </th>
          <th>
            { t('typeCodes.betCardCode') }
            <Icon
              onClick={ () => sort('betCardCode') }
              className={
                classNames({
                  'type-codes__arrow': true,
                  'type-codes__arrow--sorted': orderBy === 'betCardCode'
                })
              }
              icon="arrow"
            />
          </th>
          <th>
            { t('typeCodes.betCode') }
            <Icon
              onClick={ () => sort('betCode') }
              className={
                classNames({
                  'type-codes__arrow': true,
                  'type-codes__arrow--sorted': orderBy === 'betCode'
                })
              }
              icon="arrow"
            />
          </th>
          <th>
            { t('typeCodes.specifier1') }
          </th>
          <th>
            { t('typeCodes.specifier2') }
          </th>
        </tr>
      </thead>
      <tbody>
        {
          _.map(data, (market, index) => (
            <tr className="type-codes__rows" key={ index }>
              <td>{ market.name }</td>
              <td>{ market.betCardCode }</td>
              <td>{ market.betCode }</td>
              <td>{ market.specifier1 ? `${ market.specifier1 } - ${ market.specValue1 }` : '' }</td>
              <td>{ market.specifier2 ? `${ market.specifier2 } - ${ market.specValue2 }` : '' }</td>
            </tr>))
        }
      </tbody>
    </>
  );
}

export default SportMarket;
